export async function getToken(email, password) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/tokens/`, {
      method: "POST",
      headers: new Headers({
        Accept: "application/json",
      }),
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    });
    return await response.json();
  } catch (error) {
    return [];
  }
};

export async function signUpUser(email, password, firstName, lastName) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/users/`, {
      method: "POST",
      headers: new Headers({
        Accept: "application/json",
      }),
      body: JSON.stringify({
        email: email,
        password: password,
        first_name: firstName,
        last_name: lastName
      }),
    });
    return await response;
  } catch (error) {
    return [];
  };
};
